// Lightweight CSV + print-to-PDF exports — no external libs

const escapeCSV = (val) => {
  if (val === null || val === undefined) return "";
  const s = String(val);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

export const exportCSV = (filename, columns, rows) => {
  const header = columns.map((c) => escapeCSV(c.label)).join(",");
  const body = rows
    .map((r) =>
      columns
        .map((c) => {
          const v = typeof c.value === "function" ? c.value(r) : r[c.key];
          return escapeCSV(v);
        })
        .join(",")
    )
    .join("\n");
  const csv = "\uFEFF" + header + "\n" + body; // BOM for Excel utf-8
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const printPDF = (title, htmlBody) => {
  const w = window.open("", "_blank", "width=900,height=900");
  if (!w) return;
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"/>
<title>${title}</title>
<style>
  @page { size: A4; margin: 14mm; }
  body { font-family: 'Helvetica', Arial, sans-serif; margin: 0; color: #000; font-size: 12px; }
  .doc { padding: 20px; }
  h1 { font-size: 24px; margin: 0 0 6px; letter-spacing: -0.01em; }
  .sub { font-size: 10px; letter-spacing: 0.2em; text-transform: uppercase; color: #555; margin-bottom: 18px; }
  table { width: 100%; border-collapse: collapse; margin: 12px 0; }
  th { background: #18181b; color: #fff; padding: 8px 10px; font-size: 10px; text-transform: uppercase; letter-spacing: 0.1em; text-align: left; }
  td { padding: 7px 10px; border-bottom: 1px solid #e4e4e7; font-size: 11px; }
  .right { text-align: right; font-variant-numeric: tabular-nums; }
  .kpi-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin: 10px 0 20px; }
  .kpi { border: 1px solid #e4e4e7; padding: 10px; }
  .kpi .lbl { font-size: 9px; text-transform: uppercase; letter-spacing: 0.15em; color: #666; }
  .kpi .val { font-size: 16px; font-weight: bold; margin-top: 4px; font-variant-numeric: tabular-nums; }
  .section { font-size: 13px; font-weight: bold; margin: 22px 0 6px; padding-bottom: 4px; border-bottom: 2px solid #000; }
  .actions { padding: 14px 0; border-top: 1px solid #ccc; margin-top: 30px; display: flex; gap: 10px; justify-content: center; }
  .btn { padding: 8px 20px; border: 1px solid #000; background: #fff; cursor: pointer; font-size: 11px; text-transform: uppercase; letter-spacing: 0.1em; }
  .btn-primary { background: #000; color: #fff; }
  @media print { .actions { display: none; } .doc { padding: 0; } }
</style></head><body><div class="doc">${htmlBody}
<div class="actions">
  <button class="btn" onclick="window.close()">Close</button>
  <button class="btn btn-primary" onclick="window.print()">Print / Save as PDF</button>
</div>
</div></body></html>`);
  w.document.close();
};

export const fmtINRPlain = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(Number(n || 0));
